import {Component, inject, OnInit, signal, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  MatDialog
} from '@angular/material/dialog';
import {
  WebRtcCommunicationComponent
} from '@projects/web-rtc-communication/src/app/web-rtc-communication/web-rtc-communication.component';
import {ActivatedRoute, Router} from '@angular/router';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {TablerIconsModule} from 'angular-tabler-icons';
import {MaterialModule} from '@app/material.module';
import {BroadcastChannelService} from '@core/broadcast-channel/broadcast-channel.service';
import {Subscription, merge, tap} from 'rxjs';
import {Title} from '@angular/platform-browser';
import {SupportSidebarRoomComponent} from '@components/sidebar/support-sidebar-room/support-sidebar-room.component';
import {RoomsService} from '@services/api/rooms/rooms.service';
import {Room} from '@interfaces/room';
import {Technician} from '@interfaces/technician';
import {environment} from '@environment/environment';
import {FilemanagerSidebarComponent} from '@components/sidebar/filemanager-sidebar/filemanager-sidebar.component';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {FilemanagerApiService} from '@services/api/filemanager/filemanager-api.service';
import {ModalsSendFileComponent} from '@components/modals/modals-send-file/modals-send-file.component';

import { ModalFileManagerComponent } from '@app/components/modals/modal-file-manager/modal-file-manager.component';
import { SharedDataService } from '@app/core/services/share-data/share-data.service';
import { FilemanagerPinnableStateService } from '@app/core/services/filemanager-pinnable-state/filemanager-pinnable-state.service';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { defaults } from '@app/config';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ExplorerService, INode } from 'filemanager-explorer';
import { AudioTranslatorService, TranslationResult } from '@projects/web-rtc-communication/src/app/services/audio-translator.service';
import { ConversationArchiveService } from '@app/core/services/conversation-archive/conversation-archive.service';

import { TranslateModule } from '@ngx-translate/core';

declare var FaceBlur: any;
@Component({
  selector: 'app-support-streaming',
  imports: [
    CommonModule,
    WebRtcCommunicationComponent,
    MaterialModule,
    SupportSidebarRoomComponent,
    NgScrollbarModule,
    TablerIconsModule,
    FilemanagerSidebarComponent,
    MatButtonToggleModule,
    TranslateModule,
    // CdkDrag,
    // CdkDragHandle,
    // ResizableDirective
  ],
  standalone: true,
  templateUrl: './support-streaming.component.html',
  styleUrl: './support-streaming.component.scss'
})
export class SupportStreamingComponent implements OnInit {

  // backendUrl = '/streaming';
  backendUrl = environment.nodeHost;
  connectionId = 'streaming';

  sidePanelOpened = false;
  rightPanelOpened = false;
  room!: Room;
  technician!: Technician | undefined;
  avatar_url = environment.avatar_url;

  @ViewChild('webRtcCommunication') webRtcCommunication!: WebRtcCommunicationComponent;
  @ViewChild(MatSidenav) sidenav!: MatSidenav;
  @ViewChild('sidenavContainer') sidenavContainer!: MatSidenavContainer;
  private subscription!: Subscription;
  private translationArchiveSubscription!: Subscription;
  private broadcastService: BroadcastChannelService = inject(BroadcastChannelService);
  private room_service: RoomsService = inject(RoomsService);
  private filemanager_service: FilemanagerApiService = inject(FilemanagerApiService);
  private matDialog = inject(MatDialog);
  private titleService: Title = inject(Title);

  protected filemanagerMode: 'sidebar' | 'modal' = 'modal';
  protected sidebarMode = signal<'over' | 'side'>('over');
  protected pinnedState = signal<boolean>(defaults.modalpinned);
 

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sharedDataService: SharedDataService,
    private filemanagerPinnableStateService: FilemanagerPinnableStateService,
    private snackBar: MatSnackBar,
    private _explorerService:ExplorerService,
    private audioTranslatorService: AudioTranslatorService,
    private conversationArchiveService: ConversationArchiveService
  ) {
      // this.filemanagerPinnableStateService.clearState();
  }

  ngOnInit() {
    const uuid = this.route.snapshot.paramMap.get('uuid');
    if (!uuid) {
      this.router.navigate(['/support/room/list']);
      return;
    }
    this.connectionId = uuid;
    this.conversationArchiveService.setRoom(uuid);
    // Spoken phrases (translated or only written down) and typed messages all go into the call document
    this.translationArchiveSubscription = merge(
      this.audioTranslatorService.translations$,
      this.audioTranslatorService.typedMessages$,
    ).subscribe((result: TranslationResult) => {
      this.conversationArchiveService.record(result);
    });
    this.room_service.getRoom(this.connectionId).subscribe(room => {
      this.room = room.data;
      this.technician = this.room?.technician;
      if (this.technician?.avatar) {
        this.avatar_url = this.technician.avatar;
      }
    });
    //this.titleService.setTitle("test");
    this.connectBroadcastChannel();
    if (this.isOver()) {
      this.sidePanelOpened = false;
      this.rightPanelOpened = false;
    }
    this.initFilemanaderSidebarState();

  }

  initFilemanaderSidebarState() {
    this.filemanagerPinnableStateService.filemanagerPinnedState$.pipe(tap((state: boolean) => {
      this.pinnedState.set(state);
    })).subscribe(state => {
      this.filemanagerMode = state ? 'sidebar' : 'modal';
      this.sidebarMode.set(state ? 'side' : 'over');
      if (this.sidePanelOpened) {
        
        // qui vuole dire che eera aperto e quindi lo chiudiamo
        // this.sidePanelOpened = state;
        this.sidenav.close();
        this.sidePanelOpened = false;
        this.sidenav.openedChange.emit(false);
        window.dispatchEvent(new Event('resize'));
        // e adesso riapriamo la modale
        this.openFilemanager();
      }
      // else {
      //   console.log('entrato in sidebar closed to be toggled')
      // }
    }); 
  }
  onOpenedChange(open: boolean) {
    this.sidenavContainer.updateContentMargins();
  }
  toggleSidePanel() {
    this.sidePanelOpened = !this.sidePanelOpened;
  }

  isOver(forceState?: boolean): boolean {
    if (forceState) {
      return forceState;
    }
    return true;
    // return window.matchMedia(`(max-width: 960px)`).matches;
  }

  openFilemanager() {
   let dialogRef = this.matDialog.open(ModalFileManagerComponent, {
      data: { title: 'Documenti' },
      panelClass: ['filemanager-dialog','dialog-resizable'],
      hasBackdrop:false,
      disableClose: true,
      width: 'auto',
      minHeight: '60vh',
      maxHeight: '90vh',
      maxWidth: '90vw',
    })

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.modalpinned) {
        this.filemanagerMode = result.modalpinned ? 'sidebar' : 'modal';
        console.log(result)
        // this.sidePanelOpened = true;
        this.sidenav.open();
        this.isOver(false);
      } else {
        this.filemanagerMode = 'modal';
        this.sidePanelOpened = false;
        this.isOver(true);
      }
    });
  }
  closeFilemanager() {
    let dialogRef = this.matDialog;
    if (dialogRef) {
      dialogRef.closeAll();
    }
  }

  connectBroadcastChannel() {
    this.broadcastService.connect();
    this.subscription = this.broadcastService.getMessages().subscribe((message) => {
      switch (message['event']) {
        case 'saveScreenshot': {
          const base64 = message['data']['dataUrl'];
          this.saveScreenShot(base64, message['data']['filename']);
          break;
        }
        default: {
          break;
        }

      }
    });
  }

  private saveScreenShot(base64: string, filename?: string) {
    this.filemanager_service.saveFileScreenshotPromise(base64, filename).then((response) => {

      this.snackBar.open('Foto salvata nei Documenti', 'Chiudi', {duration: 3000})

      let data_save = response['data'];
      let uuid_file = data_save.image_uuid as string;
      this.filemanager_service.getFileBytes(uuid_file).subscribe({
        next: (response_save) => {
          let data_response = {
            id: data_save.id,
            data: response_save,
            name: data_save.name ?? filename ?? 'screenshot_'+uuid_file,
            uuid: uuid_file,
            // draggable: true,
            // resizable: true,
            // modal: true,
            // showClose: true,
          };
           let data_inode:INode = {
              id: Math.random(),
              name: filename ?? 'screenshot_'+uuid_file,
              parentId: 3,
              isLeaf: true,
              expanded: false,
              children: [],
              data: data_response,
            }
          console.log('data_inode', data_inode)
            this._explorerService.openFile(data_inode);
          if (this.filemanagerMode === 'sidebar') {
            this.filemanagerPinnableStateService.setState(true);
            this.toggleSidePanel();
          } else {
            this.openFilemanager();
          }

          // this.matDialog.open(ModalsSendFileComponent, {
          //   data: data_response,
          //   width: 'auto',
          //   minHeight: '60vh',
          //   maxHeight: '100vh',
          //   maxWidth: '90vw',
          // });
        }
      });
    }).catch((err) => {
      console.log(err);
      this.snackBar.open('Non è stato possibile salvare la foto', 'Chiudi', {duration: 3000, panelClass: 'error-snackbar'})
    });
  }

  ngOnDestroy() {
    this.conversationArchiveService.finalize();
    this.subscription?.unsubscribe();
    this.translationArchiveSubscription?.unsubscribe();
    // this.filemanagerPinnableStateService.clearState();
  }

  loadLibraryDisabled = false;
  loadLibrary() {
    this.webRtcCommunication.loadBlurVideoFilterLibrary().then(() => {
      this.loadLibraryDisabled = true;
      this.loadModelDisabled = false;
      this.loadModel();
    })
    // FaceBlur.loadLibraries().then(() => {
    //   this.loadLibraryDisabled = true;
    //   this.loadModelDisabled = false;
    //   this.loadModel();
    // })
  }

  loadModelDisabled = true;
  loadModel() {

    this.webRtcCommunication.loadBlurVideoFilterModel().then(() => {
      this.loadModelDisabled = true;
      this.startBlurDisabled = false;
    })

    // FaceBlur.loadModels().then(() => {
    //   this.loadModelDisabled = true;
    //   this.startBlurDisabled = false;
    // })
  }

  startBlurDisabled = true;

  startBlur() {
    // FaceBlur.startFaceDetection('Video');
    this.webRtcCommunication.startBlur();
    this.startBlurDisabled = true;
  }

  stopBlur() {
    this.webRtcCommunication.stopBlur();
    this.startBlurDisabled = false;
  }

  // FaceBlur.loadLibraries()
// FaceBlur.loadModels()

// FaceBlur.startFaceDetection('Video');

// FaceBlur.startFaceDetection('Video',{ 
//   model: 'ssd',
//   blurRadius: 12,
//   detectionInterval: 100,
//   faceTimeout: 1000,
//   fps: 25,
//   inputSize: 224, treshold:0.4
// });

}
